module.exports = __webpack_public_path__ + "static/img/cont3616.5e6e177.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3616.jpg
// module id = wGge
// module chunks = 0